<template>
  <div class="SelectWidget" :disabled="values === null">
    <div class="_field">
      {{selectedValue || placeholder}}
    </div>
    <div class="_options" :hidden="!optionsVisible">
      <div class="_option" v-for="value in (values || [])" :key="value" @click="selectOption(value)">
        {{value}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectWidget',
    props: ['values', 'placeholder', 'selectedValue', 'selectValue'],
    data() {
      return { optionsVisible: false }
    },
    methods: {
      selectOption(value) {
        this.selectValue(value);
      },
      toggleOptionsVisibility(ev) {
        // Clicking on the field element toggles the options. Clicking anywhere else dismisses them.
        const fieldElem = this.$el.querySelector('._field')
        this.optionsVisible = (ev.target === fieldElem && !this.optionsVisible)
      },
    },
    mounted() {
      document.documentElement.addEventListener('click', this.toggleOptionsVisibility)
    },
    beforeDestroy() {
      document.documentElement.removeEventListener('click', this.toggleOptionsVisibility)
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/svg-data';

  .SelectWidget {

    width: 440px;
    max-width: 100%;
    margin-top: 45px;
    font-family: var(--display-text);
    font-weight: bold;
    font-size: 32px;
    line-height: 1;
    position: relative;

    &[disabled] {

      opacity: 0.25;

      ._field {

        cursor: default;
      }
    }

    ._field {

      padding: 7px 10px;
      border-bottom: solid 3px;
      cursor: pointer;

      &::after {
        content: svg-data((width: 32px, height: 32px, viewBox: -16 -16 32 32),
          '<polyline points="-12,-6 0,6 12,-6" fill="none" stroke="black" stroke-width="2"/>'
        );
        position: absolute;
        top: 12px;
        right: 2px;
      }
    }

    ._options {

      border: thin solid #d8dada;
      background-color: white;
      position: absolute;
      width: 100%;
      box-sizing: border-box;
      z-index: 1;
      max-height: 390px;
      overflow-y: auto;
      overflow-x: hidden;

      ._option {

        padding: 15px;
        cursor: pointer;

        &:hover {
          background-color: #f2f3f5;
        }
      }
    }
  }
</style>
